export default __webpack_public_path__ + "static/media/video.fec25e47.mov";